import { __styles } from '@griffel/react';
export const useRootStyles = __styles({
  root: {
    B8gzw0y: "f1dd5bof"
  }
}, {
  m: [["@media (forced-colors: active){.f1dd5bof{forced-color-adjust:auto;}}", {
    m: "(forced-colors: active)"
  }]]
});